import { get } from '@/unit/request.js'
export default {
    list (data) {
        return get('/message/list', data)
    }
}